import * as React from 'react';
import * as cx from 'classnames';
import isAbsoluteUrl from 'ha/utils/isAbsoluteUrl';
import { withIntl, IntlProps } from 'ha/i18n';

const isAnchorRef = (ref: string) => /^#/.test(ref);
interface Props {
  to: string;
  className?: string;
  target?: '_blank' | '_self';
  title?: string;
  noFollow?: boolean;
  skipLangFormat?: boolean;
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  linkRef?: (r: HTMLAnchorElement) => void;
  itemScope?: boolean;
  itemType?: string;
}

const Link: React.SFC<Props & IntlProps> = ({
  to = '/',
  children,
  noFollow,
  className,
  target,
  skipLangFormat,
  intl: { urlResolver },
  linkRef,
  ...rest
}) => {
  const isTargetBlank = target === '_blank';

  return (
    <a
      href={
        isAnchorRef(to) || isAbsoluteUrl(to) || skipLangFormat
          ? to
          : urlResolver.formatHrefURL(to)
      }
      target={target}
      className={className}
      rel={cx({
        nofollow: noFollow,
        noopener: isTargetBlank,
        noreferrer: isTargetBlank,
      })}
      ref={linkRef}
      {...rest}
    >
      {children}
    </a>
  );
};

export default withIntl(Link);
